import KBaseMapMarker from "@/components/Maps/KBaseMapMarker";
import HistoryIcon from "../mixins/history-icon";
import KHistoryInfoWindow from "../info-windows/KHistoryInfoWindow";
import { formatDate, formatTime } from "kinnect-formatters";
import { zIndexMap } from "@/data/map-markers";

export default {
	name: "KHistoryMarker",

	props: {
		isFirst: Boolean,
		isLast: Boolean,
		item: Object
	},

	mixins: [ HistoryIcon ],

	computed: {
		title() {
			if ( this.item.endDate ) {
				const startDateTime = `${formatDate( this.item.date )} from ${formatTime( this.item.date )}`;
				const endTime = formatTime( this.item.endDate );

				return `${startDateTime} to ${endTime}`;
			}

			const dateTime = `${formatDate( this.item.date )} at ${formatTime( this.item.date )}`;

			if ( this.isFirst ) {
				return `Trip started on ${dateTime}`;
			} else if ( this.isLast ) {
				return `Trip completed on ${dateTime}`;
			}

			return dateTime;
		},

		zIndex() {
			if ( this.isFirst ) {
				return zIndexMap.start;
			} else if ( this.isLast ) {
				return zIndexMap.end;
			} else if ( !this.item.speed ) {
				return zIndexMap.stopped;
			}

			return zIndexMap.directionSmall;
		}
	},

	render() {
		return <KBaseMapMarker
			autoPan
			icon={this.markerIcon}
			lat={this.item.lat}
			lng={this.item.lng}
			markerId={this.item.date}
			markerType="history"
			title={this.title}
			zIndex={this.zIndex}
			scopedSlots={{
				active: () => <KHistoryInfoWindow
					item={this.item}
				></KHistoryInfoWindow>
			}}
		></KBaseMapMarker>;
	}
};
